import Route from "@ember/routing/route";
import RSVP from "rsvp";
import { service } from "@ember/service";

export default class IpsReserveRoute extends Route {
  @service store;
  @service router;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  model() {
    let dataCenters = this.store.peekAll("data-center");
    let { project } = this.modelFor("organization");

    return RSVP.hash({
      project,
      dataCenters,
      servers: project.get("servers"),
    });
  }
}
